import {
  IPrismicTitleTextMultiColumnImageTitleTextItem,
  ITitleTextMultiColumnImageTitleText,
  IItem,
} from './types';

export const mapTitleTextMultiColumnImageTitleText = ({
  prismicContent,
}): ITitleTextMultiColumnImageTitleText => {
  const items: IItem[] = prismicContent.items.map(
    (item: IPrismicTitleTextMultiColumnImageTitleTextItem) => {
      const {
        image: { url: image, alt },
      } = item;

      return {
        ...item,
        image,
        alt,
      };
    },
  );

  const {
    button_label: buttonLabel,
    internal_link: internalLink,
    external_link: externalLink,
  } = prismicContent.primary;

  const titleTextMultiColumnImageTitleText: ITitleTextMultiColumnImageTitleText =
    {
      ...prismicContent.primary,
      buttonLabel,
      link: internalLink || externalLink?.url,
      items,
    };

  return titleTextMultiColumnImageTitleText;
};
